import { SyntheticEvent, useState } from "react";
import { Skeleton, Stack, styled, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import { Block } from "@mui/icons-material";

interface Props {
  legendUrl: string;
}

export function CustomLegendUrlImage(props: Props) {
  const { legendUrl } = props;
  const { t } = useTranslation();
  const [loadState, setLoadState] = useState<"init" | "error" | "completed">(
    legendUrl ? "init" : "error"
  );

  return (
    <Styles className={loadState}>
      {loadState === "init" && <Skeleton variant="rectangular" width="100%" />}
      {loadState === "error" && (
        <Stack direction="row" spacing={1} alignItems="center">
          <Block className="error-icon" />
          <Typography>{t("label.unableToLoadLegend")}</Typography>
        </Stack>
      )}
      {legendUrl !== "" && legendUrl !== undefined && (
        <img
          alt={`Legend ${legendUrl}`}
          className={loadState}
          onLoad={(event: SyntheticEvent<HTMLImageElement>) =>
            setLoadState("completed")
          }
          onError={(event: SyntheticEvent<HTMLImageElement>) =>
            setLoadState("error")
          }
          src={legendUrl}
        />
      )}
    </Styles>
  );
}

const Styles = styled("div")`
  background-color: transparent;
  display: flex;
  justify-content: flex-start;
  align-items: center;

  &.init {
    position: relative;
    .MuiSkeleton-root {
      position: absolute;
      top: 0;
      left: 0;
    }
  }

  &.error {
    .MuiSkeleton-root {
      display: none;
    }
  }

  img {
    will-change: opacity;
    &.init {
      position: absolute;
      opacity: 0;
      transition: opacity 320ms ease-in;
    }
    &.error {
      display: none;
    }
    &.completed {
      opacity: 1;
      transition: opacity 320ms ease-in;
    }
  }
`;
